import LocationBaseController from '../common/location.base.controller';
import AppConstants from '../../../config/app.constants';

class LocationCloneController extends LocationBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, LocationService, Modal, $translate, UserBranchService, BranchService, $timeout, CommonLayoutService) {
    super(Auth, $state, User, LocationService, Modal, $translate);
    this.$timeout = $timeout;
    
    this.LocationService = LocationService;
    this.UserBranchService = UserBranchService;
    this.BranchService = BranchService;
    this.User = User;
    this.CommonLayoutService = CommonLayoutService;
    
    this.sourceLocationSelected = null;
    this.sourceLocation = null;
    
    this.cloneOptions = {
      branches: true,
      lockSetup: true,
      weeklyRoutes: true,
      recurringRoutes: true,
      denominations: true,
      scheduledLoadAmounts: true,
      deliverToLocations: true,
      hoursOfOperation: true
    };
    
    this.newLocations = {};
    this.newLocationCounter = 0;
    this._newLocationsArray = [];
    
    this.userBranches = [];
    
    this.validationErrors = {};
    this.isSubmitting = false;
    
    this.sourceLocationSearchConfig = {
      results: [],
      totalRecords: 0,
      isLoading: false,
      searchKey: ''
    };
    
    this.sourceLocationDataMap = {};
    
    this.states = [
      { label: 'Alabama', value: 'AL' },
      { label: 'Alaska', value: 'AK' },
      { label: 'American Samoa', value: 'AS' },
      { label: 'Arizona', value: 'AZ' },
      { label: 'Arkansas', value: 'AR' },
      { label: 'California', value: 'CA' },
      { label: 'Colorado', value: 'CO' },
      { label: 'Connecticut', value: 'CT' },
      { label: 'Delaware', value: 'DE' },
      { label: 'District Of Columbia', value: 'DC' },
      { label: 'Florida', value: 'FL' },
      { label: 'Georgia', value: 'GA' },
      { label: 'Guam', value: 'GU' },
      { label: 'Hawaii', value: 'HI' },
      { label: 'Idaho', value: 'ID' },
      { label: 'Illinois', value: 'IL' },
      { label: 'Indiana', value: 'IN' },
      { label: 'Iowa', value: 'IA' },
      { label: 'Kansas', value: 'KS' },
      { label: 'Kentucky', value: 'KY' },
      { label: 'Louisiana', value: 'LA' },
      { label: 'Maine', value: 'ME' },
      { label: 'Maryland', value: 'MD' },
      { label: 'Massachusetts', value: 'MA' },
      { label: 'Michigan', value: 'MI' },
      { label: 'Minnesota', value: 'MN' },
      { label: 'Mississippi', value: 'MS' },
      { label: 'Missouri', value: 'MO' },
      { label: 'Montana', value: 'MT' },
      { label: 'Nebraska', value: 'NE' },
      { label: 'Nevada', value: 'NV' },
      { label: 'New Hampshire', value: 'NH' },
      { label: 'New Jersey', value: 'NJ' },
      { label: 'New Mexico', value: 'NM' },
      { label: 'New York', value: 'NY' },
      { label: 'North Carolina', value: 'NC' },
      { label: 'North Dakota', value: 'ND' },
      { label: 'Northern Mariana Islands', value: 'MP' },
      { label: 'Ohio', value: 'OH' },
      { label: 'Oklahoma', value: 'OK' },
      { label: 'Oregon', value: 'OR' },
      { label: 'Pennsylvania', value: 'PA' },
      { label: 'Puerto Rico', value: 'PR' },
      { label: 'Rhode Island', value: 'RI' },
      { label: 'South Carolina', value: 'SC' },
      { label: 'South Dakota', value: 'SD' },
      { label: 'Tennessee', value: 'TN' },
      { label: 'Texas', value: 'TX' },
      { label: 'Utah', value: 'UT' },
      { label: 'Vermont', value: 'VT' },
      { label: 'Virgin Islands', value: 'VI' },
      { label: 'Virginia', value: 'VA' },
      { label: 'Washington', value: 'WA' },
      { label: 'West Virginia', value: 'WV' },
      { label: 'Wisconsin', value: 'WI' },
      { label: 'Wyoming', value: 'WY' }
    ];
  }

  $onInit() {
    this.loadUserBranches();
    this.addNewLocationRow();
    this.searchSourceLocations('', 0);
  }

  /**
   * Load user's accessible branches
   */
  loadUserBranches() {
    const userId = this.User.getUser().id;
    this.UserBranchService.getUserBranches(userId)
      .then((data) => {
        this.userBranches = data.results || [];
        this.resetAvailableBranches();
      })
      .catch((err) => {
        console.error('Error loading user branches:', err);
        const errorMessage = (err && err.data && err.data.message) ? err.data.message : 'Error loading branches';
        this.Modal.errorModal(errorMessage);
      });
  }

  searchSourceLocations(searchKey = '', offset = 0) {
    this.sourceLocationSearchConfig.isLoading = true;
    this.sourceLocationSearchConfig.searchKey = searchKey;
    
    const branchId = this.User.getUser().branchId;
    const searchObj = {
      queryJSON: {
        rules: [
          {
            field: 'branchId',
            condition: '=',
            data: branchId
          }
        ],
        operator: 'AND'
      }
    };

    if (searchKey && searchKey.trim()) {
      searchObj.queryJSON.rules.push({
        group: {
          rules: [
            {
              field: 'id',
              condition: 'like',
              data: `%${searchKey.trim()}%`
            },
            {
              field: 'name',
              condition: 'like',
              data: `%${searchKey.trim()}%`
            }
          ],
          operator: 'OR'
        }
      });
    }

    this.LocationService.getAllLocation(searchObj, offset, AppConstants.defaultPageLimit)
      .then((responseData) => {
        if (offset === 0) {
          this.sourceLocationSearchConfig.results = [];
          this.sourceLocationSearchConfig.totalRecords = responseData.total || 0;
        }
        
        if (responseData.results && Array.isArray(responseData.results)) {
          const newResults = responseData.results.map((locationItem) => {
            this.sourceLocationDataMap[locationItem.id] = locationItem;
            
            return {
              Key: `${locationItem.id} | ${locationItem.name}`,
              Value: locationItem.id,
              locationType: locationItem.locationType,
              name: locationItem.name
            };
          });
          
          if (offset === 0) {
            this.sourceLocationSearchConfig.results = newResults;
          } else {
            this.sourceLocationSearchConfig.results = this.sourceLocationSearchConfig.results.concat(newResults);
          }
        }
      })
      .catch((error) => {
        console.error('Error searching source locations:', error);
        const errorMessage = (error && error.data && error.data.message) ? error.data.message : 'Error searching locations';
        this.Modal.errorModal(errorMessage);
      })
      .finally(() => {
        this.sourceLocationSearchConfig.isLoading = false;
      });
  }

  onSourceLocationSelected() {
    this.$timeout(() => {
      if (!this.sourceLocationSelected || !this.sourceLocationSelected.Value) {
        this.sourceLocation = null;
        this.resetCloneOptions();
        return;
      }

      const selectedLocationId = this.sourceLocationSelected.Value;
      
      if (this.sourceLocation && this.sourceLocation.id === selectedLocationId) {
        return;
      }
      
      this.loading = true;
      this.LocationService.get(selectedLocationId)
        .then((locationData) => {
          this.sourceLocationDataMap[selectedLocationId] = locationData;
          this.sourceLocation = locationData;
          this.resetCloneOptions();
          this.clearAllBranchSelections();
        })
        .catch((error) => {
          console.error('Error loading source location:', error);
          const errorMessage = (error && error.data && error.data.message) ? error.data.message : 'Error loading source location';
          this.Modal.errorModal(errorMessage);
          this.resetSourceLocationSelection();
        })
        .finally(() => {
          this.loading = false;
      });

    }, 0);
  }

  resetCloneOptions() {
    this.cloneOptions = {
      branches: true,
      lockSetup: true,
      weeklyRoutes: true,
      recurringRoutes: true,
      denominations: true,
      scheduledLoadAmounts: true,
      deliverToLocations: true,
      hoursOfOperation: true
    };
  }

  toggleCloneOption(optionName) {
    if (optionName === 'branches') {
      this.$timeout(() => {
        this.clearAllBranchSelections();
        this.resetAvailableBranches();
      }, 0);
    }
  }

  clearAllBranchSelections() {
    Object.keys(this.newLocations).forEach((locationKey) => {
      if (this.newLocations[locationKey]) {
        this.newLocations[locationKey].branchIds = [];
        this.newLocations[locationKey].branches = [];
        this.newLocations[locationKey].branchId = null;
        this.newLocations[locationKey].availableBranches = this.createBranchListCopy();
        if (this.newLocations[locationKey].errors) {
          delete this.newLocations[locationKey].errors.branches;
        }
      }
    });
  }

  resetAvailableBranches() {
    Object.keys(this.newLocations).forEach((locationKey) => {
      if (this.newLocations[locationKey]) {
        this.newLocations[locationKey].availableBranches = this.createBranchListCopy();
      }
    });
  }

  getAvailableBranchesForRow(locationKey) {
    if (!this.newLocations[locationKey]) {
      return [];
    }
    
    if (!this.newLocations[locationKey].availableBranches) {
      this.newLocations[locationKey].availableBranches = this.createBranchListCopy();
    }
    
    return this.newLocations[locationKey].availableBranches;
  }

  createBranchListCopy() {
    if (this.userBranches && this.userBranches.length > 0) {
      return this.userBranches.map(branch => ({
        branchId: branch.branchId,
        ticked: false
      }));
    }
    return [];
  }

  onNonUSToggle(locationKey) {
    const location = this.newLocations[locationKey];
    if (!location) return;
    
    if (location.isNonUSLocation) {
      location.state = '';
      location.country = '';
    } else {
      location.state = '';
      location.country = 'US';
    }
    this._newLocationsArray = [];
  }

  hasAnyNonUSLocation() {
    return Object.values(this.newLocations).some(loc => loc && loc.isNonUSLocation === true);
  }
  
  addNewLocationRow() {
    const locationKey = `loc_${this.newLocationCounter++}`;
    this.newLocations[locationKey] = {
      id: '',
      name: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      country: 'US',
      isNonUSLocation: false,
      branchIds: [],
      branches: [],
      availableBranches: this.createBranchListCopy(),
      errors: {}
    };
    this._newLocationsArray = [];
  }

  removeLocationRow(key) {
    delete this.newLocations[key];
    this._newLocationsArray = [];
  }

  getSourceLocationType() {
    return (this.sourceLocation && this.sourceLocation.locationType) ? this.sourceLocation.locationType : 'N/A';
  }

  getSourceLocationBranches() {
    if (!this.sourceLocation) return 'N/A';
    
    if (this.sourceLocation.locationBranches && Array.isArray(this.sourceLocation.locationBranches) && this.sourceLocation.locationBranches.length > 0) {
      const branchIds = this.sourceLocation.locationBranches.filter((b) => b);
      return branchIds.length > 0 ? branchIds.join(', ') : 'N/A';
    }
    
    if (this.sourceLocation.branchId) {
      return this.sourceLocation.branchId;
    }
    
    return 'N/A';
  }

  getSourceLocationFundingSource() {
    if (!this.sourceLocation) return 'N/A';
    
    if (this.sourceLocation.bankSource && this.sourceLocation.bankSource.Key) {
      return this.sourceLocation.bankSource.Key;
    }
    
    return this.sourceLocation.bankSourceId || 'N/A';
  }

  getSourceLocationStopProcess() {
    if (!this.sourceLocation || !this.sourceLocation.stopProcess) return 'N/A';
    
    const stopProcessList = this.CommonLayoutService.stopProcessList();
    const stopProcess = stopProcessList.find(sp => sp.value === this.sourceLocation.stopProcess);
    return stopProcess ? stopProcess.label : this.sourceLocation.stopProcess;
  }

  getSourceLocationRouteLikeRegular() {
    return (this.sourceLocation && this.sourceLocation.handleAtmLikeRegular) ? 'ON' : 'OFF';
  }

  getSourceLocationId() {
    if (this.sourceLocation && this.sourceLocation.id) {
      return this.sourceLocation.id;
    }
    if (this.sourceLocationSelected && this.sourceLocationSelected.Value) {
      return this.sourceLocationSelected.Value;
    }
    return null;
  }

  validateAllLocations() {
    this.validationErrors = {};
    let isValid = true;
    const locationIds = new Set();
    const errorMessages = [];
    let rowNumber = 1;

    Object.keys(this.newLocations).forEach((key) => {
      const location = this.newLocations[key];
      location.errors = {};
      const rowErrors = [];

      if (!location.id || !location.id.trim()) {
        location.errors.id = true;
        rowErrors.push('Location ID');
        isValid = false;
        } else {
          if (locationIds.has(location.id.trim())) {
          location.errors.id = true;
          rowErrors.push(`Location ID "${location.id.trim()}" is duplicated`);
          isValid = false;
        } else {
          locationIds.add(location.id.trim());
        }
      }

      if (!location.name || !location.name.trim()) {
        location.errors.name = true;
        rowErrors.push('Name');
        isValid = false;
      }

      if (!location.address || !location.address.trim()) {
        location.errors.address = true;
        rowErrors.push('Address');
        isValid = false;
      }

      if (!location.city || !location.city.trim()) {
        location.errors.city = true;
        rowErrors.push('City');
        isValid = false;
      }

      if (!location.state || !location.state.trim()) {
        location.errors.state = true;
        rowErrors.push('State');
        isValid = false;
      }

      if (!location.zip || !location.zip.trim()) {
        location.errors.zip = true;
        rowErrors.push('Zip');
        isValid = false;
      } else {
        const zipPattern = /^\d{5,6}$/;
        if (!zipPattern.test(location.zip.trim())) {
          location.errors.zip = true;
          rowErrors.push('Zip (must be 5-6 digits)');
          isValid = false;
        }
      }

      if (location.isNonUSLocation) {
        if (!location.country || !location.country.trim()) {
          location.errors.country = true;
          rowErrors.push('Country');
          isValid = false;
        } else {
          const countryPattern = /^[a-zA-Z ]*$/;
          if (!countryPattern.test(location.country.trim())) {
            location.errors.country = true;
            rowErrors.push('Country (invalid format)');
            isValid = false;
          }
        }
      } else {
        location.country = 'US';
      }
      
      if (location.isNonUSLocation && location.state && location.state.trim()) {
        const statePattern = /^[a-zA-Z ]*$/;
        if (!statePattern.test(location.state.trim())) {
          location.errors.state = true;
          rowErrors.push('State (invalid format)');
          isValid = false;
        }
      }

      if (!this.cloneOptions.branches) {
        const selectedBranches = location.branches;
        
        let hasBranches = false;
        if (selectedBranches && Array.isArray(selectedBranches) && selectedBranches.length > 0) {
          hasBranches = selectedBranches.some(branch => branch && branch.branchId);
        }
        
        if (!hasBranches && location.availableBranches && Array.isArray(location.availableBranches)) {
          hasBranches = location.availableBranches.some(branch => branch && branch.ticked === true);
        }
        
        if (!hasBranches) {
          location.errors.branches = true;
          rowErrors.push('Location Branch');
          isValid = false;
        }
      }

      if (rowErrors.length > 0) {
        const locationId = (location.id && location.id.trim()) ? `"${location.id.trim()}"` : `Row ${rowNumber}`;
        const fieldsList = rowErrors.join(', ');
        errorMessages.push(`${locationId}: ${fieldsList} ${rowErrors.length === 1 ? 'is' : 'are'} required`);
      }

      rowNumber++;
    });

    return {
      isValid: isValid,
      errorMessages: errorMessages
    };
  }

  async validateLocationIdsUniqueness() {
    const locationIds = Object.values(this.newLocations)
      .map((loc) => (loc && loc.id) ? loc.id.trim() : '')
      .filter((id) => id);

    if (locationIds.length === 0) {
      return { isValid: true, duplicateIds: [] };
    }

    try {
      const validationResponse = await this.LocationService.validateLocationIds(locationIds);
      
      if (validationResponse && validationResponse.existingIds && validationResponse.existingIds.length > 0) {
        const existingIds = validationResponse.existingIds;
        
        Object.keys(this.newLocations).forEach((locationKey) => {
          const locationId = (this.newLocations[locationKey] && this.newLocations[locationKey].id) 
            ? this.newLocations[locationKey].id.trim() 
            : '';
          if (existingIds.indexOf(locationId) !== -1) {
            this.newLocations[locationKey].errors.id = true;
          }
        });
        
        return { isValid: false, duplicateIds: existingIds };
      }

      return { isValid: true, duplicateIds: [] };
    } catch (error) {
      console.error('Error validating location IDs:', error);
      const errorMessage = (error && error.data && error.data.message) 
        ? error.data.message 
        : 'Unable to validate location IDs';
      this.Modal.errorModal(errorMessage);
      return { isValid: false, duplicateIds: [] };
    }
  }

  async submit() {
    this.validationErrors = {};
    Object.keys(this.newLocations).forEach((key) => {
      this.newLocations[key].errors = {};
    });

    if (!this.sourceLocation || !this.sourceLocation.id) {
      this.Modal.errorModal('Please select a source location');
      return;
    }
    
    const sourceLocationId = this.sourceLocation.id;

    const validationResultMsgs = this.validateAllLocations();
    if (!validationResultMsgs.isValid) {
      const errorMessage = validationResultMsgs.errorMessages.length > 0
        ? validationResultMsgs.errorMessages[0]
        : 'Please complete all required fields';
      this.Modal.errorModal(errorMessage);
      return;
    }

    const validationResult = await this.validateLocationIdsUniqueness();
    if (!validationResult.isValid) {
      const duplicateIdsList = validationResult.duplicateIds.join(', ');
      this.Modal.errorModal(`These IDs already exist: ${duplicateIdsList}`);
      return;
    }

    const newLocationsArray = Object.values(this.newLocations)
      .filter((location) => {
        const locationId = (location && location.id) ? location.id.trim() : '';
        const locationName = (location && location.name) ? location.name.trim() : '';
        return locationId && locationName;
      })
      .map((location) => {
        const locationData = {
          id: location.id.trim(),
          name: location.name.trim(),
          address: location.address.trim(),
          city: location.city.trim(),
          state: location.state.trim(),
          zip: location.zip.trim(),
          country: location.country || 'US'
        };
        
        if (!this.cloneOptions.branches) {
          let branchIds = [];
          
          if (location.branches && Array.isArray(location.branches) && location.branches.length > 0) {
            branchIds = location.branches.map(b => b && b.branchId ? b.branchId : null).filter(id => id !== null);
          }
          
          if (branchIds.length === 0 && location.availableBranches && Array.isArray(location.availableBranches)) {
            branchIds = location.availableBranches
              .filter(branch => branch && branch.ticked === true)
              .map(branch => branch.branchId)
              .filter(id => id);
          }
          
          if (branchIds.length > 0) {
            locationData.branchIds = branchIds;
          }
        }
        
        return locationData;
      });

    if (newLocationsArray.length === 0) {
      this.Modal.errorModal('Please add at least one location');
      return;
    }

    const cloneData = {
      sourceLocationId: sourceLocationId,
      cloneOptions: { ...this.cloneOptions },
      newLocations: newLocationsArray
    };

    this.isSubmitting = true;
    this.loading = true;

    try {
      const result = await this.LocationService.cloneLocation(cloneData);
      
      if (result && result.success) {
        const createdCount = (result.createdLocations && Array.isArray(result.createdLocations)) 
          ? result.createdLocations.length 
          : 0;
        
        if (result.errors && result.errors.length > 0) {
          const errorDetails = result.errors.map(e => `${e.locationId}: ${e.error}`).join('\n');
          const message = `${createdCount} created, ${result.errors.length} failed:\n${errorDetails}`;
          
          // if (result.geocodeErrors && result.geocodeErrors.length > 0) {
          //   console.info('Geocoding errors:', result.geocodeErrors);
          // }
          
          this.Modal.errorModal(message);
        } else {
          const locationIds = result.createdLocations && Array.isArray(result.createdLocations) 
            ? result.createdLocations.join(', ') 
            : '';
          
          const message = createdCount === 1 
            ? `Created location successfully: ${locationIds}`
            : `Created ${createdCount} locations successfully: ${locationIds}`;
          
          // if (result.geocodeErrors && result.geocodeErrors.length > 0) {
          //   console.info('Geocoding errors:', result.geocodeErrors);
          // }
          
          this.Modal.successModal({
            header: this.$translate.instant('successModal.title'),
            message: message,
            callback: ({ modal }) => {
              modal.close();
              this.reset();
            },
            buttons: ['common.ok']
          });
        }
      } else {
        const errorMsg = (result && result.message) ? result.message : 'Failed to create locations';
        let errorDetails = '';
        if (result && result.errors && Array.isArray(result.errors) && result.errors.length > 0) {
          errorDetails = '\n' + result.errors.map(e => `${e.locationId || 'Unknown'}: ${e.error}`).join('\n');
        }
        this.Modal.errorModal(errorMsg + errorDetails);
      }
    } catch (err) {
      console.error('Error cloning locations:', err);
      let errorMessage = 'Failed to create locations';
      if (err && err.data && err.data.message) {
        errorMessage = err.data.message;
      } else if (err && err.message) {
        errorMessage = err.message;
      }
      this.Modal.errorModal(errorMessage);
    } finally {
      this.isSubmitting = false;
      this.loading = false;
    }
  }

  reset() {
    this.resetSourceLocationSelection();
    this.newLocations = {};
    this.newLocationCounter = 0;
    this.validationErrors = {};
    this.sourceLocationSearchConfig.results = [];
    this.sourceLocationSearchConfig.totalRecords = 0;
    this.sourceLocationSearchConfig.searchKey = '';
    this.sourceLocationDataMap = {};
    this.addNewLocationRow();
    this.searchSourceLocations('', 0);
  }

  cancel() {
    this.reset();
  }

  buildSourceLocationDetails(locationData) {
    let branchesDisplay = 'N/A';
    if (locationData && locationData.locationBranches && Array.isArray(locationData.locationBranches)) {
      branchesDisplay = locationData.locationBranches.map(lb => {
        return lb.branchId || (lb.branch && lb.branch.id) || lb.id || '';
      }).filter(b => b).join(', ');
    } else if (locationData && locationData.branchId) {
      branchesDisplay = locationData.branchId;
    }
    
    let bankSourceName = 'N/A';
    if (locationData && locationData.bankSource && locationData.bankSource.sourceName) {
      bankSourceName = locationData.bankSource.sourceName;
    } else if (locationData && locationData.bankSourceId) {
      bankSourceName = locationData.bankSourceId;
    }
    
    return {
      locationType: (locationData && locationData.locationType) ? locationData.locationType : 'N/A',
      branches: branchesDisplay,
      fundingSource: bankSourceName,
      stopProcess: (locationData && locationData.stopProcess) ? locationData.stopProcess : 'N/A',
      routeLikeRegular: (locationData && locationData.handleAtmLikeRegular) ? 'ON' : 'OFF'
    };
  }

  resetSourceLocationSelection() {
    this.sourceLocationSelected = null;
    this.sourceLocation = null;
  }

  getNewLocationsArray() {
    const currentKeys = Object.keys(this.newLocations).sort().join(',');
    const cachedKeys = this._newLocationsArray.map(loc => loc.key).sort().join(',');
    
    if (currentKeys !== cachedKeys) {
      this._newLocationsArray = Object.keys(this.newLocations).map(locationKey => ({
        key: locationKey,
        ...this.newLocations[locationKey]
      }));
    }
    
    return this._newLocationsArray;
  }

  getNewLocationsCount() {
    return Object.keys(this.newLocations).length;
  }

  shouldShowBranchColumn() {
    return !this.cloneOptions.branches;
  }

}

export default LocationCloneController;




// WEBPACK FOOTER //
// ./client/app/components/location/clone/location.clone.controller.js